import { PUBLISHED_PACKAGES } from '@syncanix/shared';

/**
 * B27(6) — install-command truthfulness.
 *
 * The docs show install/run commands, and a command for a package that is
 * not yet live on its public registry errors for every real customer (the
 * D27 `PUBLISHED_PACKAGES` SoT tracks per-package status — the CLI is live
 * on npm; the SDKs/adapters are still `planned`). The docs code-block
 * renderer calls {@link plannedPackagesIn} and shows a localized
 * "available at launch" note whenever a block references a not-yet-live
 * package. The note is derived from the SoT at render time, so flipping a
 * package to `live` (D27's publish run) clears the note with ZERO page
 * edits.
 */

/** Does this code block reference the given published package? */
function references(code: string, publishName: string, id: string): boolean {
  if (id === 'cli') {
    // The CLI publishes UNSCOPED as `syncanix`; its name would substring-match
    // everything, so match its command forms instead.
    return /\bnpx syncanix\b|\bnpm (?:install|i) (?:-g )?syncanix\b/.test(code);
  }
  return code.includes(publishName);
}

/** Labels of SoT packages referenced by `code` that are not yet live. */
export function plannedPackagesIn(code: string): readonly string[] {
  return PUBLISHED_PACKAGES.filter(
    (p) => p.status !== 'live' && references(code, p.publishName, p.id),
  ).map((p) => p.label);
}
